import Swiper from 'swiper/bundle';

window.addEventListener('load', function () {
	const buildCarousel = (el, baseConfig) => {
		const selector = `#${el.id}`;
		const container = `.${el.id}-container`;
		const config = {
			...baseConfig,
			navigation: {
				nextEl: `${container} .swiper-button-next`,
				prevEl: `${container} .swiper-button-prev`,
			},
			pagination: {
				el: `${container} .swiper-pagination`,
				clickable: true,
			},
		};
		new Swiper(selector, config);
	};
	const carousels = [
		{
			selector: '.rma-full-review-carousel',
			config: {
				slidesPerView: 1,
				spaceBetween: 10,
				grabCursor: true,
				autoHeight: true,
			},
		},
		{
			selector: '.rma-multi-slide-carousel',
			config: {
				slidesPerView: 1,
				spaceBetween: 10,
				grabCursor: true,
				breakpointsBase: 'container',
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 10,
					},
					640: {
						slidesPerView: 2,
						spaceBetween: 10,
					},
					960: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
					1200: {
						slidesPerView: 4,
						spaceBetween: 20,
					},
				},
			},
		},
	];

	carousels.forEach(({ selector, config }) => {
		document
			.querySelectorAll(selector)
			.forEach((el) => buildCarousel(el, config));
	});
});